import { useQuery } from '@tanstack/react-query';
import type { SkillLibraryListing } from '../types';

export default function useSkillLibrary() {
  return useQuery<SkillLibraryListing>({
    queryKey: ['skill-library'],
  });
}
